.container {
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    height: 100px;
    box-sizing: border-box;
}
